import useDialog from './useDialog'
import { CreateUserProps } from '../components/dialogs/User/CreateUser'

const useCreateUserDialog = () => useDialog<CreateUserProps>('create-user')

export default useCreateUserDialog
